export const environment = {
  version: '__39a777ee__',
  production: false,
  development: true,
  staging: false,
  test: false,
  enableServiceWorker: true,
  baseUrl: '/apim-proxy/gruntruder/api/',
  entra: {
    enabled: true,
    loginApiUrl: '/apim-proxy/gruntruder/api/v1/login-entra',
    clientId: '030b808e-e76a-4aa2-b07f-2ef42dc3a958',
    tenantId: '8ed4eeb4-253f-480a-80ec-4176be6711ad',
    redirectUri: '',
    scopes: ['user.read'],
  },
  mockUrl: 'http://localhost:3001',
  idleTime: 1800000, // 30 min,
  fullCalendarLicenseKey: '0324763033-fcs-1769607850',
  firebaseConfig: {
    apiKey: 'AIzaSyDziCYDb_MOJerRmHIv9lXgGR3qRRT_hL0',
    authDomain: 'dedasiat.firebaseapp.com',
    projectId: 'dedasiat',
    storageBucket: 'dedasiat.firebasestorage.app',
    messagingSenderId: '639047109126',
    appId: '1:639047109126:web:54fde5bd79b9179e155187',
    measurementId: 'G-32MPYEFKCJ',
  },
};
